Profiling.Sessions ||= {}

class Profiling.Sessions.ListView extends Backbone.View
  template: JST['backbone/templates/profiling/sessions/session_list']

  events:
    'click .owned-session .details' : 'restoreSession'
    'click .remove_session'         : 'removeSession'
    # 'click .copy_session'           : 'copySession'
    # 'click .remove_all_session'     : 'removeAllSessions'
    'input #session-search'   : 'searchSessions'

  initialize: (@options = {}) ->
    @sessions = @options.sessions
    @users = @options.users
    @canDelete = true

  render: ->
    @$el.html(@template({sessions: @sessions}))
    return this

  restoreSession: (event) =>
    session = @_getSession(event)
    @restoreSessionFromSession(session)

  restoreSessionFromSession: (session) =>
    @eventAggregator.trigger('clickOnRestoreSession', session , => @trigger('destroyFromRestore'))

  removeSession: (event) =>
    if @canDelete
      swal({
        title: I18n.t('monitoring.dashboard.session.modal_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: I18n.t('monitoring.dashboard.session.s_yes'),
        cancelButtonText: I18n.t('monitoring.dashboard.session.s_cancel'),
        closeOnConfirm: true
      }, =>
        @canDelete = false
        @eventAggregator.trigger('clickOnRemoveSession', @_getSession(event))
      )

  removeAllSessions: (event) =>

  copySession: (event) =>

  searchSessions: (event) =>
    inputValue = $(event.target).get(0).value
    sessions = @$el.find('.saved-session')
    for session in sessions
      if @_sessionMatches(@_sessionName(session), inputValue)
        $(session).show()
      else
        $(session).hide()

  _getSession: (event) ->
    listEl = $(event.target).parents('.saved-session')
    uuid = listEl.data('uuid')
    _.find(@sessions, (session) -> session.id == uuid)

  _triggerModalOpened: ->
    setTimeout () ->
      Backbone.trigger('copySessionModal:opened')
    , 100

  _sessionName: (session) ->
    $(session).find('.name').text().trim()

  _sessionMatches:(name, text) ->
    name.toUpperCase().indexOf(text.toUpperCase()) != -1